module.exports = __webpack_public_path__ + "static/img/2_4_1.80d69de4.jpg";